import React, { useState } from "react";
import { Button } from "components/core/basic/Button";
import CenteredModal from "../basic/CenteredModal";
import { Col, Row } from "react-bootstrap";
import { HStack } from "../../../../styled-system/jsx";

interface Props {
  title?: string;
  confirmationMessage: React.ReactNode;
  onConfirm: () => void;
  confirmButtonText: string;
  modalButtonText: React.ReactNode;
  loading?: boolean;
  loadingModalButtonText?: string;
  buttonStyle?: string;
  disableConfirmButton?: boolean;
  modelButtonStyle?: React.CSSProperties;
  modelButtonClass?: string;
  disabled?: boolean;
  inlineModal?: boolean;
  onCancel?: () => void;
  inlineButtonContainerStyles?: React.CSSProperties;
  defaultShowState?: boolean;
  cancelButtonStyles?: React.CSSProperties;
  confirmButtonStyles?: React.CSSProperties;
  hideCancelButton?: boolean;
}

const ConfirmationModal = ({
  title,
  confirmationMessage,
  onConfirm,
  confirmButtonText,
  modalButtonText,
  loading,
  loadingModalButtonText,
  disableConfirmButton = false,
  modelButtonStyle = { marginRight: "2rem" },
  inlineModal = false,
  onCancel,
  inlineButtonContainerStyles,
  defaultShowState = false,
  cancelButtonStyles = {},
  confirmButtonStyles = {},
  hideCancelButton = false,
}: Props) => {
  const [showModal, setShowModal] = useState(defaultShowState);

  const modalButtonTextToDisplay = loading ? loadingModalButtonText : modalButtonText;

  return (
    <>
      {showModal && (
        <CenteredModal
          show={showModal}
          closeModal={() => {
            setShowModal(false);
            onCancel?.();
          }}
          title={title ? title : ""}
          dialogClassName={"modal-60w"}
        >
          <Row
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "20px 10px",
              textAlign: "center",
            }}
          >
            <Col style={{ margin: "0 20px" }} xs={12}>
              {confirmationMessage}
            </Col>
          </Row>
          <HStack justifyContent="space-around">
            {!hideCancelButton && (
              <Button
                variant={"secondary"}
                onPress={() => {
                  setShowModal(false);
                  onCancel?.();
                }}
                style={cancelButtonStyles}
              >
                Cancel
              </Button>
            )}
            <Button
              onPress={() => {
                onConfirm();
                setShowModal(false);
              }}
              isDisabled={disableConfirmButton}
              style={confirmButtonStyles}
            >
              {confirmButtonText}
            </Button>
          </HStack>
        </CenteredModal>
      )}

      {!inlineModal ?
        <Button onPress={() => setShowModal(!showModal)} style={modelButtonStyle}>
          {modalButtonTextToDisplay}
        </Button>
      : <div
          style={
            inlineButtonContainerStyles ? inlineButtonContainerStyles : (
              { width: "100%", height: "100%", textAlign: "left" }
            )
          }
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowModal(true);
          }}
        >
          {modalButtonTextToDisplay}
        </div>
      }
    </>
  );
};

export default ConfirmationModal;
